import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

const FULL = /^\d{4}-\d{2}-\d{2}$/;
const sane = (v) => { if (!FULL.test(v)) return false; const y = Number(v.slice(0, 4)); return y >= 1990 && y <= 2100; };

// Input tanggal yang aman saat diketik: state lokal, hanya kirim ke parent bila lengkap & tahun wajar (hindari reset saat tahun diketik sebagian, mis. 0002).
export default function DateInput({ value, onChange, className = "", ...props }) {
  const [local, setLocal] = useState(value || "");
  useEffect(() => { setLocal(value || ""); }, [value]);
  const openPicker = (e) => { try { e.currentTarget.showPicker?.(); } catch { /* browser lama */ } };
  return (
    <Input type="date" {...props} className={className} value={local}
      onClick={openPicker}
      onChange={(e) => { const v = e.target.value; setLocal(v); if (v === "" || sane(v)) onChange(v); }}
      onBlur={(e) => { const v = e.target.value; if (!sane(v)) { setLocal(value || ""); if (v !== "" && value) onChange(value); } else if (v !== value) onChange(v); }} />
  );
}
